module.exports = __webpack_public_path__ + "static/img/icon-close.0f1f5b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon-close.png
// module id = xulM
// module chunks = 0